/* tslint:disable */
/* eslint-disable */
export enum CreateMemoConflictType {
  VerificationNotFound = 'verification_not_found'
}
